import { useEffect, useState } from 'react'

const useMouseDownElement = () => {
  const [id, setId] = useState<string | null>(null)
  const [className, setClassName] = useState<string | null>(null)

  useEffect(() => {
    const onMousedownHandler = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      setId(target?.id)
      setClassName(target?.classList?.value)
    }

    document.addEventListener('mousedown', onMousedownHandler)

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', onMousedownHandler)
    }
  }, [])

  return {
    id,
    className,
  }
}

export default useMouseDownElement
